import React from "react";

import {
  ACCOUNT_IS_TAX_EXEMPT,
  COUNT_TOWARDS_CURRENT_YEAR,
} from "../../constants";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import TooltipBasic from "@src/sharedComponents/Tooltip/TooltipBasic";
import toUSD from "@src/utils/toUSD";

import styles from "../basicTable.module.css";
export interface HypotheticalProposalDisplay {
  currentMarketValue: string;
  ytdNetGainsRealized: string;
  hypotheticalGainsRealized: string;
  hypotheticalLossesHarvested: string;
  taxesPaid: string;
}

interface CapitalGainsTaxesTableProps {
  budgetAmount: number;
  proposalWithoutTaxBudget: HypotheticalProposalDisplay;
  proposalWithTaxBudget: HypotheticalProposalDisplay;
  anAccountIsTaxAdvantaged: boolean;
  currentMarketValue: number;
}

const CapitalGainsTaxesTableV2: React.FC<CapitalGainsTaxesTableProps> = ({
  budgetAmount,
  anAccountIsTaxAdvantaged,
  proposalWithoutTaxBudget,
  proposalWithTaxBudget,
  currentMarketValue,
}) => {
  return (
    <table className={styles.table}>
      <thead className={styles.thead}>
        <tr className={styles.headerRow}>
          <td className={styles.cell}></td>
          <td className={toClassName(styles.headerCell, styles.textSubtle)}>
            Without a Tax Budget
          </td>
          <td className={styles.headerCell}>With a Tax Budget</td>
        </tr>
      </thead>

      <tbody>
        <tr className={styles.row}>
          <td className={styles.cell}>Tax Budget Amount</td>
          <td className={styles.cell}>Unlimited</td>
          <td className={styles.cell}>{toUSD(budgetAmount)}</td>
        </tr>

        <tr className={styles.row}>
          <td className={styles.cell}>Current Market Value</td>
          <td className={styles.cell}>{toUSD(currentMarketValue)}</td>
          <td className={styles.cell}>{toUSD(currentMarketValue)}</td>
        </tr>

        <tr className={styles.row}>
          <td className={styles.cell}>YTD Net Gains Realized</td>
          <td className={styles.cell}>
            {proposalWithoutTaxBudget.ytdNetGainsRealized}
          </td>
          <td className={styles.cell}>
            {proposalWithTaxBudget.ytdNetGainsRealized}
          </td>
        </tr>

        <tr className={styles.row}>
          <td className={styles.cell}>Hypothetical Gains Realized</td>
          <td className={styles.cell}>
            {proposalWithoutTaxBudget.hypotheticalGainsRealized}
          </td>
          <td className={styles.cell}>
            {proposalWithTaxBudget.hypotheticalGainsRealized}
          </td>
        </tr>

        <tr className={styles.row}>
          <td className={styles.cell}>Hypothetical Losses Harvested</td>
          <td className={styles.cell}>
            {`(${proposalWithoutTaxBudget.hypotheticalLossesHarvested})`}
          </td>
          <td className={styles.cell}>
            {`(${proposalWithTaxBudget.hypotheticalLossesHarvested})`}
          </td>
        </tr>

        <tr className={styles.footerRow}>
          <td className={styles.cell}>
            <div className={styles.flexRow}>
              <div>Taxes Paid</div>
              <TooltipBasic
                className={styles.infoIcon}
                text={`${COUNT_TOWARDS_CURRENT_YEAR} ${
                  anAccountIsTaxAdvantaged ? ACCOUNT_IS_TAX_EXEMPT : ""
                }`}
              />
            </div>
          </td>
          <td className={styles.cell}>{proposalWithoutTaxBudget.taxesPaid}</td>
          <td className={styles.cell}>{proposalWithTaxBudget.taxesPaid}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default CapitalGainsTaxesTableV2;
